module.exports = __webpack_public_path__ + "img/ione3.650af024.png";